<p-dialog header="Pos Details" [(visible)]="display" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <div><strong>Name</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.name}}</div>
            </div>
            <div class="p-col-4 p-md-2">
                <div><strong>Item</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.itemNo}}</div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <div><strong>Type</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.type}}</div>
            </div>
            <div class="p-col-4 p-md-2">
                <div><strong>Product Categories</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.productCategories}}</div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <div><strong>Manufacter Name</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.manufacturerName}}</div>
            </div>
            <div class="p-col-4 p-md-2">
                <div><strong>Barcode</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.barCode}}</div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <div><strong>Buy Price</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.buyPrice}}</div>
            </div>
            <div class="p-col-4 p-md-2">
                <div><strong>Sell Price</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.sellPrice}}</div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <div><strong>Qty in hand</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.availableToSellQty}}</div>
            </div>
            <div class="p-col-4 p-md-2">
                <div><strong>vendor</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.vendor}}</div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <div><strong>Face Cost</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.faceCost}}</div>
            </div>
            <div class="p-col-4 p-md-2">
                <div><strong>Description</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.description}}</div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <div><strong>Taxable</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.taxable}}</div>
            </div>
            <div class="p-col-4 p-md-2">
                <div><strong>Colour Type</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.colourType}}</div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <div><strong>Cost Percent</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.costPercent}}</div>
            </div>
            <div class="p-col-4 p-md-2">
                <div><strong>MinPrice</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.minPrice}}</div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <div><strong>Reference Num</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.referenceNum}}</div>
            </div>
            <div class="p-col-4 p-md-2">
                <div><strong>Avg. Cost</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.avgCost}}</div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <div><strong>Created Date</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.createdDate | date : "MM/dd/yyyy"}}</div>
            </div>
            <div class="p-col-4 p-md-2">
                <div><strong>Updated Date</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{posView?.updatedDate | date : "MM/dd/yyyy"}}</div>
            </div>
        </div>
    </div>
    
    <p-footer>
      <button pButton (click)="onClose()" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
  </p-dialog>